var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id in _vm.$store.state.errors)?_c('div',{staticClass:"form-error ion-margin-bottom",attrs:{"id":_vm.id + '-error'}},[_vm._v(_vm._s(_vm.$store.state.errors[_vm.id]))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }